import axios from 'axios'
import Toast from '@/components/Toast/Toast.vue'
export default
    name:'Login'
    components:{
        Toast
    },
    data:()->
        username: ''
        password: ''
        userData: ''
        isForgetPassword:false
        recoveryEmail:''
        flagError: false
    mounted:()->
        this.init();
        this.check();
    methods:
        init:()->
            this.dataAPIs()

        dataAPIs:()->    

        check:()->
            self = this
            url = "/api/v1/test"  
            axios.get(url).then((res) ->
               console.log("chek all")
            ).catch (err) ->
              
        login:()->
            self = this
            url = "/api/v1/Login"
            payload={
                email: self.username
                password: self.password
            }
            axios.post(url,payload).then((res) ->
                axios.defaults.headers.common['token'] = res.data.data.token
                console.log("check res",res.data.data);
                localStorage.userData = JSON.stringify(res.data)
                self.$nextTick ->
                    self.$store.dispatch('setUser')
                    self.$store.dispatch('setMenu')
                    self.$router.push(this.$store.state.menu[0].link)
                    
                # this.$routes.path
            ).catch (err) ->
                self.flagError=true
                console.log(self.flagError)
                    
        toggleForgetModal:()->
            this.isForgetPassword = !this.isForgetPassword
        

